var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    clipPath: "url(#clip0_2098_938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14ZM14.5017 10.3354C13.14 10.9018 10.4185 12.0741 6.33721 13.8522C5.67447 14.1158 5.3273 14.3736 5.2957 14.6257C5.24228 15.0517 5.77583 15.2195 6.50238 15.448C6.60121 15.4791 6.70361 15.5113 6.80859 15.5454C7.52341 15.7777 8.48496 16.0496 8.98484 16.0604C9.43827 16.0702 9.94435 15.8832 10.5031 15.4996C14.3164 12.9255 16.2848 11.6244 16.4084 11.5964C16.4955 11.5766 16.6164 11.5517 16.6982 11.6245C16.7801 11.6972 16.772 11.835 16.7634 11.872C16.7105 12.0973 14.6161 14.0444 13.5323 15.0521C13.1944 15.3662 12.9548 15.589 12.9058 15.6399C12.796 15.7539 12.6841 15.8617 12.5766 15.9654C11.9126 16.6055 11.4146 17.0856 12.6042 17.8696C13.1759 18.2463 13.6334 18.5579 14.0898 18.8687C14.5882 19.2081 15.0853 19.5466 15.7285 19.9683C15.8924 20.0757 16.0489 20.1873 16.2014 20.2959C16.7814 20.7095 17.3025 21.081 17.9464 21.0217C18.3204 20.9873 18.7069 20.6355 18.9031 19.5864C19.3669 17.107 20.2786 11.7349 20.4893 9.52114C20.5077 9.32718 20.4845 9.07897 20.4658 8.97C20.4472 8.86104 20.4082 8.70579 20.2666 8.59087C20.0989 8.45476 19.8399 8.42606 19.7241 8.4281C19.1975 8.43737 18.3896 8.71829 14.5017 10.3354Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2098_938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTg);
export default __webpack_public_path__ + "static/media/icons_TG.bd2e98587c3197780a6c47f06520cf03.svg";
export { ForwardRef as ReactComponent };